/* @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ */
/* @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ 404 @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ */
/* @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ */

import * as React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Layout from "../components/layout";
import Seo from "../components/seo";
import "../styles/404-styles.css";
import Walrus from "../images/walrus-404.webp";

const NotFoundPage = () => (
  <Layout>
    <Container><Row>
      <Col xs={{order: 2, span: 12}} sm={{order: 1, span: 6}}><img src={Walrus} alt="404 Walrus" /></Col>
    <Col xs={{order: 1, span: 12}} sm={{order: 2, span: 6}} className="not-found-container">
      
      <div className="not-found-content">
        <h1 className="error-code">404</h1>
        <h2 className="error-message">Oops! Page not located.</h2>
        <p className="error-description">
          This page took an unexpected detour.
        </p>
        <p className="error-description">
          Never fear! We'll help you find your way back...
        </p>
        <button className="home-button" onClick={() => (window.location.href = '/')}> HOME</button>
      </div>

    </Col></Row></Container>
  </Layout>
);

export const Head = () => <Seo title="404: Not Found" />;

export default NotFoundPage;
